export const PDF_FILE_EXTENSIONS = ['pdf'];

export const IMAGE_FILE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'tif', 'tiff'];

export const WORD_FILE_EXTENSIONS = ['doc', 'docx', 'odt', 'rtf'];

export const SPREADSHEET_FILE_EXTENSIONS = ['xls', 'xlsx', 'csv', 'ods'];

export const ARCHIVE_FILE_EXTENSIONS = ['zip', 'rar', '7z', 'tar', 'gz'];

export const TEXT_FILE_EXTENSIONS = ['txt', 'md', 'html', 'htm', 'json', 'xml'];
